import {
  alertMessagesArgsConfig,
  browserStorageArgsConfig,
  userRoleArgsConfig,
} from '../utils/event_constants';

export const multiTenantActions = [
  {
    name: 'addNewUserToTenant',
    label: 'Add New / Existing User to Tenant',
    args: [
      userRoleArgsConfig({}),
      {
        name: 'userSettings',
        label: 'Add User Settings',
        type: 'boolean',
        value: '',
        custom: [],
      },
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
        optional: true,
      },
      ...alertMessagesArgsConfig,
      ...browserStorageArgsConfig,
    ],
  },
  {
    name: 'removeUserFromTenant',
    label: 'Remove User from Tenant',
    args: [
      {
        name: 'removeUserSettings',
        label: 'Remove Corresponding User Settings',
        type: 'boolean',
        value: '',
      },
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'switchUserTenant',
    label: 'Switch Tenant',
    args: [
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      ...alertMessagesArgsConfig,

      {
        name: 'skipPageReload',
        label: 'Skip Page Reload',
        type: 'boolean',
        value: true,
        custom: [],
      },
    ],
  },
  {
    name: 'switchSubTenant',
    label: 'Switch Sub Tenant',
    args: [
      {
        name: 'confirmationMessage',
        label: 'Alert Message',
        type: 'text',
        value: '',
      },
      ...alertMessagesArgsConfig,

      {
        name: 'skipPageReload',
        label: 'Skip Page Reload',
        type: 'boolean',
        value: true,
        custom: [],
      },
    ],
  },
  {
    name: 'updateCurrentTenantData',
    label: 'Update Current Tenant',
    args: [
      {
        name: 'constructor',
        label: 'Constructor (Optional)',
        type: 'dropdown',
        optionsType: 'tenantConstructorApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'updateCurrentUserSettingData',
    label: 'Update Current User Setting',
    args: [
      {
        name: 'constructor',
        label: 'Constructor (Optional)',
        type: 'dropdown',
        optionsType: 'tenantConstructorApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
];
